import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGooglePay = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.36,
		d: "M11.86 3.4A6 6 0 1 0 14 8H8.67"
	})
});
export default SvgGooglePay;
